'use strict';

import './assets/css/accountsReceivable.css';
import './assets/css/autocomplete.css';
import './assets/angular-tree-control/angular-tree-control.js';
import './assets/angular-tree-control/css/tree-control.css';


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/index.js